<span
    class="flex justify-center rounded-3xl border leading-none"
    [ngClass]="['chipsize-' + size, isPaletteColor ? 'chipbg-' + color : '']"
    [ngStyle]="backgroundStyles"
>
    <span class="font-normal tracking-wide text-gray-100">
        <ng-content></ng-content>
    </span>
</span>
